
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/kyosaimypage",
      function () {
        return require("private-next-pages/cases/kyosaimypage/index.tsx");
      }
    ]);
  